import React from 'react';
import {withTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({});

const FileScannerIcon = ({ className, scan_status, t, classes }) => (
  <>
    {scan_status === 'pass' && (
      <img className={className} src={`${rootUrl}/img/virus_scan_statuses/pass.svg`}/>
    )}
    {scan_status === 'pending' && (
      <img className={className} src={`${rootUrl}/img/virus_scan_statuses/pending.svg`}/>
    )}
    {scan_status === 'fail' && (
      <img className={className} src={`${rootUrl}/img/virus_scan_statuses/fail.svg`}/>
    )}
  </>
);

export default withStyles(styles)(withTranslation()(FileScannerIcon));
